export const NOTE_TEXT_MAX_LENGTH = 2500;
